import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-gestiones-infopresolicitud-tc',
  templateUrl: './gestiones-infopresolicitud-tc.component.html',
  styleUrls: ['./gestiones-infopresolicitud-tc.component.scss']
})
export class GestionesInfopresolicitudTcComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() participante: any
  constructor() { }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
}
